class CTRReviews extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.carouselSelector = this.querySelector('.swiper');

        this.initCarousel();
        
    }

    initCarousel() {
        if (!this.carouselSelector) return;

        this.swiper = new Swiper(this.carouselSelector, {
            slidesPerView: 1.2,
            spaceBetween: 24,
            draggable: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2.5,
                    spaceBetween: 32,
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });
    }

}

customElements.define('ctr-reviews', CTRReviews);